import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import { Page, SmartComponentsProvider } from '@cap/smart-render-core';

import { SmartSiteProvider, useSmartSite } from '../SmartSiteProvider';
// import { isMobile } from '../../util/device';
import { useScreenSize } from '../ScreenSize';
import { useConfigShare } from '../Share/use-config-share';
import styles from './index.module.scss';

interface IProps {
  title: string;
  description: string;
  pageUrl: string;
  [key: string]: any;
}

function SmartPageContent(props: { url: string }) {
  const { url } = props;
  const { schema } = useSmartSite(url);
  const [device, setDevice] = useState('pc');
  const { size } = useScreenSize();

  useEffect(() => {
    size.width < 1024 ? setDevice('h5') : setDevice('pc');
  }, [size.width]);

  useEffect(() => {
    const body = document.querySelector('body');
    if (!body) return;
    let bodyStyle = '';

    if (device === 'pc') {
      bodyStyle = 'background-color: #fff';
    }
    body.setAttribute('style', bodyStyle);
    // eslint-disable-next-line consistent-return
    return () => {
      body.setAttribute('style', '');
    };
  }, [device]);

  if (!schema) return null;

  return (
    <SmartComponentsProvider device={device as any} env={'production' as any}>
      <div className={styles.page} style={{ minWidth: device === 'pc' ? '1024px' : 'auto', background: '#fff' }}>
        <Page schema={schema} />
      </div>
    </SmartComponentsProvider>
  );
}

function SmartPageContainer(props: IProps) {
  const { pageUrl, title, description, ...others } = props;
  const [loaded, setLoaded] = useState(false);

  useConfigShare({
    title,
    desc: description,
    image: '',
  });
  return (
    <>
      <Head>
        <title>{title}</title>
        <link href={`https://about.meituan${pageUrl}`} key="canonical" rel="canonical" />
        <link
          href="https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:1040877d/favicon-mt.ico"
          rel="icon"
          sizes="any"
        />
        <link href="/site.webmanifest" rel="manifest" />
        <meta content={description} property="og:description" />
        <meta content={title} name="title" />
        <meta content={description} name="description" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      </Head>
      <SmartSiteProvider
        {...(others as any)}
        onLoaded={() => {
          setLoaded(true);
        }}
      >
        {loaded ? <SmartPageContent url={pageUrl} /> : null}
      </SmartSiteProvider>
    </>
  );
}

export { SmartPageContainer };
